import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import i18n from 'i18n'

export const MembersList = styled(Grid)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  maxHeight: '250px',
  paddingRight: i18n.dir() === 'ltr' ? '4px' : undefined,
  paddingLeft: i18n.dir() === 'rtl' ? '4px' : undefined
}))

export interface ParticipantAvatarContainerProps {
  color: string
}

export const ParticipantAvatarContainer = styled('div')(
  (props: ParticipantAvatarContainerProps) => ({
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    display: 'flex',
    justifyContent: 'center',

    border: props.color ? `1px solid ${props.color}` : ``,
    borderRadius: 9999
  })
)

export interface MemberListItemProps {
  canMakeActions?: boolean
}

export const MemberListItem = styled(Grid)<MemberListItemProps>(
  ({ theme, canMakeActions = true }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    fontWeight: 400,
    color: theme.palette.text.primary,
    paddingRight: i18n.dir() === 'ltr' ? theme.spacing(1) : theme.spacing(0),
    paddingLeft: i18n.dir() === 'rtl' ? theme.spacing(1) : theme.spacing(0),
    height: 30,

    borderRadius: theme.shape.borderRadius,
    transition: 'background-color 0.2s ease',

    ...(canMakeActions && {
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        cursor: 'pointer',
        '& .hover-arrow': {
          maxWidth: '20px',
          opacity: 1
        }
      }
    }),

    '& .hover-arrow': {
      maxWidth: '0px',
      opacity: 0,
      overflow: 'hidden',
      transition: 'max-width 0.3s ease, opacity 0.3s ease',
      '& rect': {
        fill: theme.palette.surface.greyButton
      },
      '& path': {
        fill: theme.palette.getContrastText(
          theme.palette.input.placeholder as string
        )
      }
    },

    '& span[data-content="role"]': {
      fontSize: '0.625rem',
      color: theme.palette.input.placeholder,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5)
    },

    '& span[data-content="pending"]': {
      fontSize: '0.625rem',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),

      color: theme.palette.input.placeholder,
      '@keyframes flickerAnimation': {
        '0%': { opacity: 1 },
        '50%': { opacity: 0 },
        '100%': { opacity: 1 }
      },
      animation: 'flickerAnimation 2s infinite'
    }
  })
)

export const MembersListNameContainer = styled(Grid)(() => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '1.10rem'
}))
